import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantSubmitPage = {
  alert: {
    error: 'applicant-submit-page.form.alert.error',
  },
  footer: {
    root: 'applicant-submit-page.footer.root',
  },
  form: {
    coapplicantDateOfBirthInput:
      'applicant-submit-page.form.coapplicant-date-of-birth-input',
    coapplicantDateOfBirthInputError:
      'applicant-submit-page.form.coapplicant-date-of-birth-input-error',
    coapplicantSectionH3: 'applicant-submit-page.form.coapplicant-section-h3',
    coapplicantSectionRoot:
      'applicant-submit-page.form.coapplicant-section-root',
    coapplicantSsnInput: 'applicant-submit-page.form.coapplicant-ssn-input',
    coapplicantSsnInputError:
      'applicant-submit-page.form.coapplicant-ssn-input-error',
    dateOfBirthInput: 'applicant-submit-page.form.date-of-birth-input',
    dateOfBirthInputError:
      'applicant-submit-page.form.date-of-birth-input-error',
    h1: 'applicant-submit-page.form.h1',
    h2: 'applicant-submit-page.form.h2',
    privacyLink: 'applicant-submit-page.form.privacy-link',
    root: 'applicant-submit-page.form.root',
    ssnInput: 'applicant-submit-page.form.ssn-input',
    ssnInputError: 'applicant-submit-page.form.ssn-input-error',
    submitButton: 'applicant-submit-page.form.submit-button',
    termsCheckbox: 'applicant-submit-page.form.terms-checkbox',
    termsCheckboxError: 'applicant-submit-page.form.terms-error',
    termsLink: 'applicant-submit-page.form.terms-link',
  },
} as const satisfies PageLocatorMap;
